import { render, staticRenderFns } from "./detalhesPedidoVenda.vue?vue&type=template&id=f7040954&scoped=true&"
import script from "./detalhesPedidoVenda.vue?vue&type=script&lang=js&"
export * from "./detalhesPedidoVenda.vue?vue&type=script&lang=js&"
import style0 from "./detalhesPedidoVenda.vue?vue&type=style&index=0&id=f7040954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7040954",
  null
  
)

export default component.exports